import Vue from 'vue'
import Vuex from 'vuex'

import version from './version'
import map from './map'
import user from './user'
import config from './config'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    version,
    map,
    user,
    config
  },
  state: {
    
  },
  getters: {

  },
  mutations: {

  },
  actions: {

  }
})
